<template>
  <div class="account-allocation-mana">
    <a-card>
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        formLayout="inline"
        @fetchSearch="handleSearch"
      ></SearchView>
      <TableView
        ref="table"
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        rowKey="bpmId"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:amount="{ tableRow }">
          {{ tableRow.amount | formatAmount }}
        </template>
        <template v-slot:reduceAmount="{ tableRow }">
          {{ formatSepicelAmount(tableRow.reduceAmount) }}
        </template>
        <template v-slot:allocatedAmount="{ tableRow }">
          {{ formatSepicelAmount(tableRow.allocatedAmount) }}
        </template>
        <template v-slot:assignableAmount="{ tableRow }">
          {{ tableRow.assignableAmount | formatAmount }}
        </template>
        <template v-slot:action="{ tableRow }">
          <a-button
            type="primary"
            @click="getAllocations(tableRow)"
            v-if="tableRow.status === 1"
          >
            额度分配
          </a-button>
        </template>
      </TableView>
    </a-card>
    <a-modal
      v-model="visible"
      destroyOnClose
      @cancel="handleCancel"
      :width="650"
      :confirm-loading="loading"
      @ok="handleSubmit"
    >
      <a-descriptions style="padding:20px 0px;">
        <a-descriptions-item label="母公司">
          {{ detail.parentName }}
        </a-descriptions-item>
        <a-descriptions-item label="额度类型">
          {{ detail.typeStr }}
        </a-descriptions-item>
        <a-descriptions-item label="可分配额度">
          {{ detail.assignableAmount | formatAmount }}
        </a-descriptions-item>
        <a-descriptions-item label="到期日">
          {{ detail.indateEnd }}
        </a-descriptions-item>
      </a-descriptions>

      <a-form-model :model="modalForm" ref="modalForm" :rules="rules">
        <a-form-model-item label="子公司" prop="childCode">
          <a-select v-model="modalForm.childCode">
            <a-select-option v-for="item in childList" :key="item.code">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="信控区" prop="creditArea">
          <a-select v-model="modalForm.creditArea">
            <a-select-option v-for="item in creditList" :key="item.name">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="额度金额" prop="amount">
          <a-input allowClear v-model="modalForm.amount"></a-input>
        </a-form-model-item>
        <a-form-model-item label="到期日" prop="indateEnd">
          <a-date-picker
            v-model="modalForm.indateEnd"
            @change="(date, dateString) => handleChange(dateString)"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择到期日期"
            style="width: 100%;"
          />
          <a-form-model-item label="备注说明" prop="remark">
            <a-input
              allowClear
              :maxLength="200"
              v-model="modalForm.remark"
            ></a-input>
          </a-form-model-item>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  getNormalList,
  getBusinessList,
  getAllocateOverview,
  doLoanAllocate,
} from './api'
import { TableView, SearchView } from 'lxfintech-fe'
import numeral from 'numeral'
import { ERR_OK } from 'config/index'
import moment from 'moment'
const formatAmount = num => {
  return numeral(num).format('0,0.00')
}
export default {
  name: 'account-allocation-mana',
  data() {
    const searchSchema = [
      {
        label: '母公司名称',
        type: 'input',
        itemName: 'parentName',
        allowClear: true,
      },
      {
        label: '母公司ID',
        type: 'input',
        itemName: 'parentCode',
        allowClear: true,
      },
      {
        label: '额度类型',
        itemName: 'type',
        type: 'select',
        selectList: [
          { text: '全部', value: '' },
          { text: '正常额度', value: 2 },
          { text: '临时额度', value: 3 },
        ],
        allowClear: true,
      },
      {
        label: '状态',
        itemName: 'status',
        type: 'select',
        selectList: [
          { text: '全部', value: '' },
          { text: '已生效', value: 1 },
          { text: '已失效', value: 2 },
        ],
        allowClear: true,
      },
    ]
    const tableColumns = [
      {
        fixed: 'left',
        title: '序号',
        width: 60,
        customRender: (text, record, index) => {
          return (
            (this.pageData.current - 1) * this.pageData.pageSize + index + 1
          )
        },
      },
      {
        title: '母公司ID',
        width: 210,
        dataIndex: 'parentCode',
      },
      {
        title: '母公司名称',
        width: 200,
        dataIndex: 'parentName',
      },
      {
        title: '额度类型',
        width: 220,
        dataIndex: 'typeStr',
      },
      {
        title: '业务类型',
        width: 180,
        dataIndex: 'business',
      },
      {
        title: '信控区',
        width: 180,
        dataIndex: 'creditRange',
      },
      {
        title: '额度生效状态',
        width: 180,
        dataIndex: 'statusStr',
      },
      {
        title: '到期日',
        width: 180,
        dataIndex: 'indateEnd',
      },
      {
        title: '最终批复额度',
        width: 180,
        scopedSlots: { customRender: 'amount' },
        dataIndex: 'amount',
      },
      {
        title: '金额单位',
        width: 180,
        dataIndex: 'moneyType',
      },
      {
        title: '调减后额度',
        scopedSlots: { customRender: 'reduceAmount' },
        width: 180,
        dataIndex: 'reduceAmount',
      },
      {
        title: '已分配额度',
        width: 180,
        scopedSlots: { customRender: 'allocatedAmount' },
        dataIndex: 'allocatedAmount',
      },
      {
        title: '可分配额度',
        width: 180,
        scopedSlots: { customRender: 'assignableAmount' },
        dataIndex: 'assignableAmount',
      },
      {
        title: '操作',
        width: 120,
        fixed: 'right',
        scopedSlots: { customRender: 'action' },
      },
    ]
    const pageData = {
      pageSize: 10,
      current: 1,
      total: 0,
      showTotal: total => `共${total}条`,
    }
    return {
      tableLoading: false,
      visible: false,
      tableData: [],
      creditList: [],
      childList: [],
      formatAmount,
      tableColumns,
      rules: {
        childCode: [
          {
            required: true,
            message: '请选择子公司',
            trigger: 'change',
          },
        ],
        creditArea: [
          {
            required: true,
            message: '请选择信控区',
            trigger: 'change',
          },
        ],
        amount: [
          {
            required: true,
            message: '请输入额度金额',
            trigger: 'change',
          },
        ],
        indateEnd: [
          {
            required: true,
            message: '请选择到期日',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: '请输入备注说明',
            trigger: 'change',
          },
        ],
      },
      loading: false,
      modalForm: {
        childCode: '',
        creditArea: '',
        amount: '',
        indateEnd: '',
        remark: '',
      },
      pageData,
      searchSchema,
      searchForm: {
        status: '',
        parentName: '',
        parentCode: '',
        type: '',
      },
      detail: {},
    }
  },
  mounted() {
    this._getNormalList(this.searchForm)
    this._getBusinessList()
  },
  methods: {
    formatSepicelAmount(num) {
      if (typeof num === 'number') {
        return this.formatAmount(num)
      }
    },
    handleChange(value) {
      // 判断日期是否大于母公司到期日
      const after = moment(value).isAfter(moment(this.detail.indateEnd))
      if (after) {
        this.$warning({
          title: '提示',
          content: '到期日需小于等于母公司到期日',
        })
        this.modalForm.indateEnd = this.detail.indateEnd
      }
    },
    // 获取信控区数据
    async _getBusinessList() {
      try {
        const { data } = await getBusinessList()
        this.creditList = data
      } catch (error) {
        console.error(error)
      }
    },
    // 获取子公司数据
    async getChildList(parentCode) {
      try {
        const { data } = await getAllocateOverview({ parentCode })
        this.childList = data.children
      } catch (error) {
        console.error(error)
      }
    },
    // 关闭弹框，清空
    handleCancel() {
      this.visible = false
      this.$refs.modalForm.resetFields()
    },
    handleSubmit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          const params = {
            parentCode: this.detail.parentCode,
            childCode: this.modalForm.childCode,
            amount: this.modalForm.amount,
            creditArea: this.modalForm.creditArea,
            type: this.detail.type,
            amountId: this.detail.bpmId,
            indateEnd: this.modalForm.indateEnd,
            remark: this.modalForm.remark,
          }
          // 提交数据
          this._doAllocate(params)
          this.handleCancel()
        } else {
          console.log('验证不通过')
          return false
        }
      })
    },
    async _doAllocate(params) {
      try {
        this.loading = true
        const { code, message } = await doLoanAllocate(params)
        if (code == ERR_OK) {
          this.$notification.success({
            message: '提示',
            description: message,
          })
        } else {
          this.$notification.error({
            message: '提示',
            description: message,
          })
        }
        this.visible = false
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    // 分配额度
    getAllocations(data) {
      this.detail = data
      this.modalForm.indateEnd = data.indateEnd
      this.getChildList(data.parentCode)
      this.visible = true
    },
    // 分页
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getNormalList(this.searchForm)
    },
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1 // 设置为第一页
      this._getNormalList(this.searchForm)
    },
    async _getNormalList(searchForm) {
      try {
        this.tableLoading = true
        const { current, pageSize } = this.pageData
        const query = {
          ...searchForm,
          size: pageSize,
          current,
        }
        const {
          data: { total, records },
        } = await getNormalList(query)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.log(error)
      }
    },
  },
  components: { TableView, SearchView },
}
</script>

<style></style>
